import { FC, FormEvent, useState } from "react";

const STORAGE_KEY = "basic_auth_expiry";
const STALE_MS = 14 * 24 * 60 * 60 * 1000;

const isAuthed = () => {
	const expiry = localStorage.getItem(STORAGE_KEY);
	return expiry !== null && Date.now() < Number(expiry);
};

const BasicAuth: FC<{ children: React.ReactNode }> = ({ children }) => {
	const [authed, setAuthed] = useState(isAuthed);
	const [error, setError] = useState(false);

	if (process.env.REACT_APP_ENABLE_BASIC_AUTH !== "true" || authed) return <>{children}</>;

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const form = e.currentTarget;
		const user = (form.elements.namedItem("username") as HTMLInputElement).value;
		const pass = (form.elements.namedItem("password") as HTMLInputElement).value;

		if (
			user === process.env.REACT_APP_BASIC_AUTH_USER &&
			pass === process.env.REACT_APP_BASIC_AUTH_PASS
		) {
			localStorage.setItem(STORAGE_KEY, String(Date.now() + STALE_MS));
			setAuthed(true);
		} else {
			setError(true);
		}
	};

	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
			<form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "8px", width: "240px" }}>
				<input name="username" type="text" placeholder="Username" autoComplete="username" required />
				<input name="password" type="password" placeholder="Password" autoComplete="current-password" required />
				{error && <span style={{ color: "red", fontSize: "0.85rem" }}>Invalid credentials</span>}
				<button type="submit">Login</button>
			</form>
		</div>
	);
};

export default BasicAuth;
